import React, { useMemo } from 'react';
import type { ScheduleBlockCell } from './scheduleUtils';

type BlockProps = {
  block: ScheduleBlockCell;
  editMode: boolean;
  onBlockSetSelected: (block: ScheduleBlockCell, selected: boolean) => void;
  onPointerDownEdit: (block: ScheduleBlockCell) => void;
  onPointerEnterEdit: (block: ScheduleBlockCell) => void;
};

const Block: React.FC<BlockProps> = ({
  block,
  editMode,
  onBlockSetSelected,
  onPointerDownEdit,
  onPointerEnterEdit,
}) => {
  const { displayTime, cursor } = useMemo(() => {
    let hours = Math.floor(block.time / 100);
    let minutes = String(((block.time % 100) / 100) * 60);
    minutes = (`00${minutes}`).slice(-2);
    const amPM = hours >= 12 ? 'PM' : 'AM';
    if (hours === 0) {
      hours = 12;
    }
    if (hours > 12) {
      hours = hours % 12;
    }
    const dt = `${hours}:${minutes}${amPM}`;
    let c = 'pointer';
    if (!editMode && !block.open) {
      c = 'not-allowed';
    }
    return { displayTime: dt, cursor: c };
  }, [block.time, block.open, editMode]);

  return (
    <div
      className={`list-group-item schedule-block ${block.time < 800 || block.time >= 2200 ? 'nighttime' : ''} ${
        block.time % 100 === 50 ? 'end-of-hour' : ''
      } ${block.selected ? 'list-group-item-info' : ''} ${
        !block.selected && block.open && !editMode ? 'list-group-item-success' : ''
      } ${!block.selected && !block.open && !editMode ? 'list-group-item-danger' : ''}`}
      style={{ cursor }}
      onClick={() => {
        if (!editMode && block.open) {
          onBlockSetSelected(block, !block.selected);
        }
      }}
      onPointerDownCapture={(e) => {
        if (!editMode) {
          return;
        }
        if (e.button !== 0) {
          return;
        }
        e.preventDefault();
        onPointerDownEdit(block);
      }}
      onPointerEnter={() => {
        if (editMode) {
          onPointerEnterEdit(block);
        }
      }}
      role="presentation">
      {displayTime}
    </div>
  );
};

export default Block;
